<template>
<div class="test-content">
    <div class="symptoms-test-container insert-symptoms">
        <div class="symptoms-test-main">
            <h5>Koji su vaši simptomi?</h5>
            <div class="symptom-test-search">
                <input v-model="searchInput" @keyup="onKeyUp" type="text" class="symptom-test-input" id="symptoms-input"
                    placeholder="Upišite Vaše simptome" />
                <div class="symptom-test-search-dropdown"
                v-bind:class="{ show: showSearchResults }">
                    <ul>
                        <li class="no-result" v-if="filteredSymptoms.length === 0">Nema rezultata.</li>
                        <li 
                            v-for="(symptom, index) in filteredSymptoms" 
                            :key="symptom.id"
                            @click="onChooseSymptom(symptom)"
                            v-bind:class="{ selected: index + 1 === selectedDropdownItem }">
                            {{symptom.name}}
                        </li>
                    </ul>
                </div>
            </div>

            <h6>Najčešće traženi simptomi</h6>
            <ul class="symptoms-list symptoms-list-mobile">
                <li 
                    v-for="symptom in symptoms"
                    class="symptoms-item" 
                    data-name="Tremor"
                    :key="symptom.id">
                    {{ symptom.name }}
                    <span @click="onRemoveSymptom(symptom)">x</span>
                </li>
            </ul>
            <ul   class="symptoms-tags">
                <li 
                    v-for="symptom in featuredSymptomsToShow" 
                    :key="symptom.id" :id="symptom.id"
                    @click="onChooseSymptom(symptom)"
                    class="symptom-tag">
                    {{ symptom.name }}
                </li>
            </ul>
        </div>
        <test-data-box
            :activeStep="activeStep"
            :age="age" 
            :gender="gender" 
            :symptoms="symptoms" 
            :conditions="conditions" 
            :drugs="drugs"
            @symptomRemoved="onRemoveSymptom"
            @editData="onEditData">
        </test-data-box>
    </div>
</div>
</template>

<script>
import TestDataBox from './TestDataBox';
import fetchService from '../services/fetchService.js'

export default {
    name: 'second-step-symptoms',
    components: {
        TestDataBox,
    },

    props: ['activeStep', 'age', 'gender', 'symptoms', 'conditions', 'drugs'],

    data(){
        return {
            allSymptoms: [],
            featuredSymptoms: [],
            featuredSymptomsToShow: [],
            filteredSymptoms: [],
            selectedSymptoms: [],
            searchInput: '',
            showSearchResults: false,
            selectedDropdownItem: 0,
            numberOfDropdownItems: 0,
        }
    },

    methods: {
        async onChooseSymptom(symptom) {
            this.$emit('symptomAdded', { ...symptom });
            this.showSearchResults = false;
            this.searchInput = '';
            this.selectedSymptoms.push(symptom);
            let newPossibleSymptoms = await fetchService.fetchPossibleSymptoms(this.selectedSymptoms);
            if (newPossibleSymptoms.length > 0) {
                this.featuredSymptomsToShow = newPossibleSymptoms.slice(0,9);
            } else {
                this.featuredSymptomsToShow = this.featuredSymptoms;
            }
        },
        async onRemoveSymptom(symptom) {
            this.$emit('symptomRemoved', {...symptom});
            this.selectedSymptoms = this.removeSelectedSymptom(symptom);
            let newPossibleSymptoms = await fetchService.fetchPossibleSymptoms(this.selectedSymptoms);
            if (newPossibleSymptoms.length > 0) {
                this.featuredSymptomsToShow = this.selectedSymptoms.length > 0 
                    ? newPossibleSymptoms.slice(0,9)
                    : this.featuredSymptoms;
            } else {
                this.featuredSymptomsToShow = this.featuredSymptoms;
            }
        },

        onKeyUp(event) {
            if (event.keyCode === 40) {
                this.selectedDropdownItem =  this.selectedDropdownItem === this.numberOfDropdownItems ? 1 : this.selectedDropdownItem + 1;
            }
            if (event.keyCode === 38) {
                this.selectedDropdownItem =  this.selectedDropdownItem === 1 ? this.numberOfDropdownItems : this.selectedDropdownItem - 1;
            }
            if (event.keyCode === 13) {
                if(this.selectedDropdownItem > 0) {
                    this.onChooseSymptom(this.filteredSymptoms[this.selectedDropdownItem - 1]);
                }
            }
        },

        onEditData(step) {
            this.$emit('editData', step);
        },

        removeSelectedSymptom(symptom) {
            return this.selectedSymptoms.filter(function(item) {
                return item.id !== symptom.id;
            });
        }
    },

    async created() {
        this.featuredSymptoms = await fetchService.fetchFeaturedSymptoms();
        this.featuredSymptomsToShow = this.featuredSymptoms;
        this.allSymptoms = await fetchService.fetchPossibleSymptoms(this.selectedSymptoms);
    },

    watch: {
        searchInput: function(val, oldVal) {
            if (val.length > 1) {
                this.filteredSymptoms = this.allSymptoms.filter(function(symptom) {
                    return symptom.name.toLowerCase().includes(val.toLowerCase());
                }).slice(0,5);
                this.showSearchResults = true;
                this.selectedDropdownItem = 0;
                this.numberOfDropdownItems = this.filteredSymptoms.length;
            } else {
                this.showSearchResults = false;
            }
        }
    }
  
}
</script>

<style>
.symptom-test-search .symptom-test-search-dropdown ul li.no-result:hover {
    background-color: white;
    color: #6d6e70;
}
</style>